import { render, staticRenderFns } from "./DiscardIcon.vue?vue&type=template&id=2d6e3a60&scoped=true&"
import script from "./DiscardIcon.vue?vue&type=script&lang=js&"
export * from "./DiscardIcon.vue?vue&type=script&lang=js&"
import style0 from "./DiscardIcon.vue?vue&type=style&index=0&id=2d6e3a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e3a60",
  null
  
)

export default component.exports